import React from "react";

export function ImpressumContent() {
    return (
        <div className="prose prose-sm max-w-none prose-headings:scroll-mt-24 prose-a:text-purple-700">
            <h2 id="impressum">Impressum</h2>

            <h3>Angaben gemäß § 5 TMG</h3>
            <p>
                <strong>Johannsen IT Solutions</strong><br />
                {/* TODO: Vollständiger Name (Inhaber) */} Inhaber: Thorben Johannsen<br />
                {/* TODO: Straße + Hausnr. */} Von-Weber-Str. 7<br />
                {/* TODO: PLZ + Ort */} 26842 Ostrhauderfehn<br />
                Deutschland
            </p>

            <h3>Kontakt</h3>
            <p>
                Telefon: <a href="tel:+4915117806720">+49 151 17 80 6720</a><br />
                E-Mail: <a href="mailto:kontakt@johannsen-its.de">kontakt@johannsen-its.de</a>
            </p>

            <h3>Umsatzsteuer</h3>
            <p>
                <strong>Kleinunternehmer gemäß § 19 UStG</strong> – es wird keine Umsatzsteuer ausgewiesen.
            </p>

            {/* Optional: nur wenn zutreffend */}
            {/*
      <h3>Umsatzsteuer-ID</h3>
      <p>USt-IdNr.: DE123456789</p>
      */}

            {/* Optional: nur wenn zutreffend */}
            {/*
      <h3>Registereintrag</h3>
      <p>Eintragung im Handelsregister. Registergericht: …, Registernummer: …</p>
      */}

            <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
            <p>
                {/* TODO: Name + Anschrift (oft identisch) */}
                Thorben Johannsen<br />
                Von-Weber-Str. 7<br />
                26842 Ostrhauderfehn, Deutschland<br />
            </p>

            <h3>Haftung für Inhalte</h3>
            <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
                Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
                oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                Tätigkeit hinweisen.
            </p>

            <h3>Haftung für Links</h3>
            <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
                können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
                stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>

            <h3>Urheberrecht</h3>
            <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
                Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.
            </p>

            <hr />
        </div>
    );
}
